import React, { ReactNode, useMemo, useState } from 'react';
import {
  InputAdornment,
  InputLabel,
  makeStyles,
  TextField,
  TextFieldProps,
} from '@material-ui/core';
import classNames from 'classnames';
import { EyeCloseIcon } from 'modules/icons/EyeCloseIcon';
import { EyeIcon } from 'modules/icons/EyeIcon';

// TODO_R: [FRS]
const useStyles = makeStyles((theme) => ({
  inputRoot: {},
  root: {
    position: 'relative',
    '& .MuiOutlinedInput-root': {
      border: '1px solid #34353B',
      background: '#292A2F',
      overflow: 'hidden',
      marginBottom: 0,
    },
    '& input': {
      fontWeight: 600,
    },
    '& .MuiOutlinedInput-input': {
      padding: '16px 18px',
      color: '#fafafa',
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '20px',
      '&::placeholder': {
        fontWeight: '400!important',
      },
    },
    '& .MuiFormHelperText-root.Mui-error': {
      // position: "absolute",
      // bottom: "-36px",
      whiteSpace: 'noWrap',
      fontWeight: 400,
      fontSize: '12px',
      marginTop: '6px',
      marginBottom: '0px',
    },
    '& svg': {
      color: '#888686',
      cursor: 'pointer',
    },
  },
  labelWrapper: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 8,
  },
  label: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 500,
    color: '#FAFAFA',
    marginBottom: '0px',
  },
  balance: {
    color: '#FAFAFA',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    marginLeft: 'auto',
  },
  append: {
    color: '#888686',
  },
  inputStart: {
    minWidth: 24,
    height: 24,
    '& img, & svg': {
      width: '100%',
      height: '100%',
    },
  },
  inputEnd: {
    minWidth: 24,
    height: 24,
    marginLeft: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    '& img, & svg': {
      width: '100%',
      height: '100%',
    },
  },
  mobileFullWidth: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}));

export interface IInputFieldProps {
  type?: TextFieldProps['type'];
  label?: string;
  // TODO_R: думаю нужно вытащить логику с balance и stxPrice в отдельный компонент для SetTxFee, который будет переиспользовать InputField и добавлять эту логику сверху
  balance?: string;
  stxPrice?: number | null;
  bnsAddress?: string | null;
  disabled?: boolean;
  errorInfo?: string;
  placeHolder?: string;
  rightContent?: ReactNode;
  leftContent?: ReactNode;
  value: string | number;
  onChange?: (event: any) => void;
  onKeyDown?: (event: any) => void;
  appendContent?: ReactNode;
  mobileFullWidth?: boolean;
}

// TODO_R: move into uikit
// TODO_R: [FRS] [RCC]
export const InputField = ({
  label,
  balance,
  stxPrice,
  bnsAddress,
  type = 'text',
  disabled,
  errorInfo,
  placeHolder,
  leftContent,
  rightContent,
  value,
  appendContent,
  mobileFullWidth = false,
  onChange,
  onKeyDown,
}: IInputFieldProps) => {
  const classes = useStyles();

  const [showPassword, setShowPassword] = useState(false);

  const isPassword = useMemo(() => type === 'password', [type]);

  const inputProps = useMemo(() => {
    return {
      startAdornment: leftContent && (
        <InputAdornment position="start">
          <div className={classes.inputStart}>{leftContent}</div>
        </InputAdornment>
      ),
      endAdornment: rightContent ? (
        <InputAdornment position="end">
          <div className={classes.inputEnd}>{rightContent}</div>
        </InputAdornment>
      ) : (
        bnsAddress && (
          <InputAdornment position="end">
            <div className={classes.inputEnd}>{bnsAddress}</div>
          </InputAdornment>
        )
      ),
    };
  }, [leftContent, rightContent, bnsAddress]);

  const passwordProps = useMemo(() => {
    return {
      endAdornment: (
        <InputAdornment position="end" onClick={() => setShowPassword(!showPassword)}>
          {showPassword ? <EyeIcon /> : <EyeCloseIcon />}
        </InputAdornment>
      ),
    };
  }, [showPassword]);

  return (
    <div
      className={classNames(classes.inputRoot, mobileFullWidth && classes.mobileFullWidth)}
      // TODO_R: move into classes
      style={{ height: 'fit-content' }}
    >
      {(label || stxPrice || balance) && (
        <div className={classes.labelWrapper}>
          {Boolean(label) && <InputLabel className={classes.label}>{label}</InputLabel>}
          {stxPrice && <span>{`~ $${stxPrice.toFixed(4)}`}</span>}
          {balance && <div className={classes.balance}>Balance: {balance}</div>}
        </div>
      )}
      <TextField
        variant="outlined"
        type={isPassword ? (showPassword ? 'password' : 'text') : type}
        fullWidth
        classes={{
          root: classes.root,
        }}
        InputProps={isPassword ? passwordProps : inputProps}
        placeholder={placeHolder}
        error={!!errorInfo}
        disabled={!!disabled}
        helperText={errorInfo}
        value={value}
        onChange={onChange && onChange}
        onKeyDown={onKeyDown && onKeyDown}
      />
      {appendContent && <div className={classes.append}>{appendContent}</div>}
    </div>
  );
};
